export default __webpack_public_path__ + "static/media/_2.6f6b9d99.jpg";